var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"the-logo",attrs:{"to":{ name: 'Home' }},nativeOn:{"click":function($event){return _vm.scrollTo.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }